export const classes = {
  base: 'flex h-[52px] w-full items-center justify-center gap-2.5 rounded-full text-[15px] font-bold transition-[background,opacity] duration-150',
  primary:
    'cursor-pointer bg-grad text-white shadow-[0_14px_28px_-12px_rgba(241,90,43,0.42)] dark:bg-grad-dark dark:shadow-[0_14px_28px_-12px_rgba(0,0,0,0.5)]',
  danger:
    'cursor-pointer bg-[#e5484d] text-white shadow-[0_12px_26px_-12px_rgba(229,72,77,0.6)]',
  outline:
    'w-auto flex-none cursor-pointer border-[1.5px] border-[rgba(70,60,50,0.18)] bg-transparent px-7 text-taupe-2 dark:border-[rgba(255,255,255,0.16)] dark:text-mauve-2',
  disabled: 'cursor-not-allowed bg-[#8aa0a8]/30 text-white/70 shadow-none',
  busy: 'cursor-wait opacity-[0.82]',
  spinner:
    'size-[17px] flex-none rounded-full border-[2.4px] border-white/40 border-t-white',
};

export const styles = {
  spinner: { animation: 'spinner 0.7s linear infinite' },
};
